import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Label,
  Form,
  Input,
  Row,
  Col,
  Container
} from "reactstrap";
import { useAuth } from "contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
  const [credentials, setCredentials] = useState({ user: "", password: "" });
  const [error, setError] = useState("");
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate("/admin/asistencia-presencial", { replace: true });
    }
  }, [loading, isAuthenticated, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    const res = await login(credentials);
    if (res.success) {
      // navigate("/admin/dashboard");
      navigate("/admin/asistencia-presencial");
    } else {
      setError(res.message);
    }
  };

  return (
    <div className="content bg-default" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
      <Container>
        <Row className="justify-content-center">
          <Col md="6">
            <Card>
              <CardHeader>
                <h5 className="title text-center">SISCAFV - Iniciar Sesión</h5>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Usuario / DNI</Label>
                        <Input
                          name="user"
                          placeholder="DNI"
                          type="text"
                          value={credentials.user}
                          onChange={handleChange}
                          autoComplete="username"
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Contraseña</Label>
                        <Input
                          name="password"
                          placeholder="Contraseña"
                          type="password"
                          value={credentials.password}
                          onChange={handleChange}
                          autoComplete="current-password"
                          required
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {error && <p className="text-danger text-center">{error}</p>}
                  <div className="text-center">
                    <Button className="btn-fill" color="primary" type="submit">
                      Entrar
                    </Button>
                  </div>
                </Form>
              </CardBody>
              <CardFooter className="text-center">
                <Button color="link" size="sm" onClick={() => alert("Contacte al administrador")}>
                  ¿Olvidó su contraseña?
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Login;
